import {React} from 'components'; //eslint-disable-line

export default () => <div className='app-404'><div className="text-404">This page does not exist</div></div>;
